<ng-template #confirmDialogTemplate>
    <form class="se-auth-dialog-container se-flex se-expand" (ngSubmit)="closeModal(false)">
        <div class="se-flex se-vertical se-expand">
            <div class="se-dialog-header mat-elevation-z6" [class.se-dialog-header-error]="isOnError">
                <h3 mat-dialog-title translate><span translate>MultiAuthenticate</span></h3>
            </div>

            <div class="se-sign-dialog-content" mat-dialog-content [class.confirm-dialog-waiting]="isWaiting | async">
                <mat-tab-group
                    [(selectedIndex)]="selectedTabIndex"
                    (selectedTabChange)="onSelectedTabIndexChange($event)"
                >
                    <mat-tab *ngFor="let tab of data; let i = index" [attr.data-index]="i" aria-label="Profile tab">
                        <ng-template matTabLabel>
                            <mat-icon style="color: #e53935" *ngIf="errorMessages[i]">error</mat-icon>
                            <mat-icon style="color: #61a566" *ngIf="!errorMessages[i] && data[i].password"
                                >done
                            </mat-icon>
                            <span style="margin-left: 3px">{{ tab.userName }}</span>
                        </ng-template>
                        <ng-template matTabContent>
                            <div class="credentials">
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "Username" | translate }}</mat-label>
                                    <input
                                        name="confirm_username_{{ i }}"
                                        matInput
                                        [placeholder]="'Username' | translate"
                                        [(ngModel)]="data[i].userName"
                                        tabindex="-1"
                                        readonly
                                    />
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "Password" | translate }}</mat-label>
                                    <input
                                        #pwd
                                        name="confirm_pwd_{{ i }}"
                                        [type]="showPassword[i] ? 'text' : 'password'"
                                        matInput
                                        [placeholder]="'Password' | translate"
                                        [(ngModel)]="data[i].password"
                                        autocomplete="new-password"
                                        required
                                    />
                                    <button
                                        type="button"
                                        matSuffix
                                        mat-icon-button
                                        aria-label="Show"
                                        (click)="showPassword[i] = !showPassword[i]"
                                        tabindex="-1"
                                    >
                                        <mat-icon>{{ showPassword[i] ? "visibility_off" : "visibility" }}</mat-icon>
                                    </button>

                                    <button
                                        *ngIf="!!data[i].password"
                                        type="button"
                                        matSuffix
                                        mat-icon-button
                                        aria-label="Clear"
                                        (click)="data[i].password = ''"
                                        tabindex="-1"
                                    >
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </mat-form-field>

                                <p
                                    *ngIf="errorMessages[i]"
                                    style="flex-grow: 1; font-size: 0.9em; margin: 0 10px; color: #e53935"
                                >
                                    {{ errorMessages[i] }}
                                </p>
                            </div>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>

                <p *ngIf="errorMessage" style="flex-grow: 1; font-size: 0.9em; margin: 0 10px; color: #e53935">
                    {{ errorMessage }}
                </p>
            </div>
            <div class="se-sign-dialog-action-container" mat-dialog-actions>
                <button
                    mat-button
                    color="primary"
                    class="se-dialog-action-button"
                    type="button"
                    (click)="closeModal(true)"
                >
                    <span translate>Cancel</span>
                </button>

                <button
                    mat-button
                    class="se-dialog-action-button"
                    type="button"
                    color="primary"
                    [disabled]="!currentIsSet()"
                    (click)="handleConfirmClick()"
                >
                    <span>{{ enableAuthenticateButton() ? confirmLabel : nextLabel }}</span>
                </button>

                <button type="submit" [disabled]="!enableAuthenticateButton()" style="display: none">
                    hidden submit
                </button>
            </div>
        </div>
    </form>

    <div class="estensa-spinner" style="background-color: transparent !important" *ngIf="isWaiting | async">
        <mat-spinner diameter="64" color="accent"></mat-spinner>
    </div>
</ng-template>
